// Login storage for the admin panel. The admin token is only ever read from and
// written to localStorage here; it must never be logged to the console.

const ADMIN_TOKEN_KEY = 'admin_token';
const LOGIN_NOTICE_KEY = 'login_notice';
const COMPANY_SUSPENDED_KEY = 'company_suspended';

// Fired on window whenever the company-suspended state below is set or cleared
export const COMPANY_SUSPENSION_EVENT = 'company-suspension-changed';

// Everything that identifies who is logged in (or who is being "acted as").
// UI preferences such as defaultPageSize or periodType are deliberately kept.
const LOGIN_KEYS = [
	'access_token',
	ADMIN_TOKEN_KEY,
	'mo_user',
	'admin_level',
	'admin_id',
	'mainadmin_id',
	'main_mo_user',
	'main_admin_level',
	'companyId',
	'companyName',
	'companyInfo',
	COMPANY_SUSPENDED_KEY,
];

export function getAdminToken() {
	try {
		return localStorage.getItem(ADMIN_TOKEN_KEY);
	} catch (e) {
		return null;
	}
}

export function setAdminToken(token) {
	try {
		if (token) {
			localStorage.setItem(ADMIN_TOKEN_KEY, token);
		} else {
			localStorage.removeItem(ADMIN_TOKEN_KEY);
		}
	} catch (e) {
		// storage unavailable: the panel still works while the server does not enforce tokens
	}
}

export function clearStoredLogin() {
	LOGIN_KEYS.forEach((key) => {
		try {
			localStorage.removeItem(key);
		} catch (e) {
			// ignore
		}
	});
}

// A one-off message for the login page (e.g. after the session expired)
export function setLoginNotice(message) {
	try {
		sessionStorage.setItem(LOGIN_NOTICE_KEY, message);
	} catch (e) {
		// ignore
	}
}

// A suspended company's own admin stays signed in but is kept on the Account page (Billing tab) with a banner
// (see layouts/layout-components/suspension/suspension-banner.js). The stored value is only an on/off
// flag; the banner shows its own text.
export function getCompanySuspended() {
	try {
		return localStorage.getItem(COMPANY_SUSPENDED_KEY);
	} catch (e) {
		return null;
	}
}

export function setCompanySuspended(message) {
	try {
		localStorage.setItem(COMPANY_SUSPENDED_KEY, message);
	} catch (e) {
		// ignore
	}
	window.dispatchEvent(new Event(COMPANY_SUSPENSION_EVENT));
}

export function clearCompanySuspended() {
	let wasSet = false;
	try {
		wasSet = localStorage.getItem(COMPANY_SUSPENDED_KEY) !== null;
		localStorage.removeItem(COMPANY_SUSPENDED_KEY);
	} catch (e) {
		// ignore
	}
	if (wasSet) {
		window.dispatchEvent(new Event(COMPANY_SUSPENSION_EVENT));
	}
}

export function takeLoginNotice() {
	try {
		const message = sessionStorage.getItem(LOGIN_NOTICE_KEY);
		sessionStorage.removeItem(LOGIN_NOTICE_KEY);
		return message;
	} catch (e) {
		return null;
	}
}
